import { render, staticRenderFns } from "./SharedGenericGalleryListing.vue?vue&type=template&id=2bf12fa9"
import script from "./SharedGenericGalleryListing.vue?vue&type=script&lang=js"
export * from "./SharedGenericGalleryListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports